import { render, staticRenderFns } from "./JcOrder.vue?vue&type=template&id=ee5760ec&scoped=true&"
import script from "./JcOrder.vue?vue&type=script&lang=js&"
export * from "./JcOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5760ec",
  null
  
)

export default component.exports